module.exports = __webpack_public_path__ + "img/coupon-new.2483ea7.png";